<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center2"><span class="big">JUNGIAN<br/>SPIRITUALITY</span><br/><br/></p>
<p class="center">VIVIANNE CROWLEY</p>
<p><br/><br/><br/><br/><br/></p>
<p class="centers"><img alt="" src="OEBPS/images/logo.gif"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781446359211_epub_tp_r1.vue?7d380790